import * as React from "react";
import * as moment from "moment";
import { FaPen, FaTrashAlt, FaFile } from "react-icons/fa";
import "./list-claims.scss";
import { claimStatusFormatted } from "../ClaimForm/utils";
import { CLAIM_DOCUMENT_TYPES } from "../../ISchema";
import { colorStatus } from "../helper/claimHelper";

var ListClaims = function ListClaims(props) {
  var claims = props.claims,
      poliza = props.poliza,
      admin = props.admin;
  var canEdit = admin.is_super_admin || admin.permissions_code.includes("claim_edit");
  var canDelete = admin.is_super_admin || admin.permissions_code.includes("claim_delete");
  return /*#__PURE__*/React.createElement("div", {
    className: "panel panel-default cnt_listClaims"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/React.createElement("h4", null, "Siniestros Registrados")), /*#__PURE__*/React.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "claim-number"
  }, "Numero Siniestro"), /*#__PURE__*/React.createElement("th", {
    className: "claim-date"
  }, "Fecha Denuncia"), /*#__PURE__*/React.createElement("th", {
    className: "claim-date"
  }, "Fecha y Hora del Siniestro"), /*#__PURE__*/React.createElement("th", {
    className: "claim-provision"
  }, "Provisi\xF3n"), /*#__PURE__*/React.createElement("th", null, "Lugar"), /*#__PURE__*/React.createElement("th", {
    className: "claim-status"
  }, "Estado"), /*#__PURE__*/React.createElement("th", null, "Archivos Adicionales"), /*#__PURE__*/React.createElement("th", null, "Pagado"), /*#__PURE__*/React.createElement("th", {
    className: "claim-actions"
  }))), /*#__PURE__*/React.createElement("tbody", null, claims && claims.map(function (claim) {
    var _claim$document, _claim$document2, _claim$claim_document;

    return /*#__PURE__*/React.createElement("tr", {
      key: claim.id
    }, /*#__PURE__*/React.createElement("td", {
      className: "claim-number"
    }, claim.claim_number ? /*#__PURE__*/React.createElement("a", {
      href: "/admin/polizas/".concat(poliza.id, "/claims/").concat(claim.id, "/preview"),
      style: {
        fontSize: "13px",
        fontWeight: "600",
        color: "#2596be",
        textDecoration: "none",
        letterSpacing: "0.5px",
        cursor: "pointer",
        padding: "2px 4px",
        borderRadius: "3px",
        transition: "all 0.2s ease"
      },
      onMouseEnter: function onMouseEnter(e) {
        e.currentTarget.style.backgroundColor = "#e3f2fd";
        e.currentTarget.style.color = "#1976d2";
      },
      onMouseLeave: function onMouseLeave(e) {
        e.currentTarget.style.backgroundColor = "transparent";
        e.currentTarget.style.color = "#2596be";
      },
      title: "Ver previsualizaci\xF3n del siniestro"
    }, claim.claim_number) : "-"), /*#__PURE__*/React.createElement("td", {
      className: "claim-date"
    }, claim.request_date ? moment(claim.request_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
      className: "claim-date"
    }, claim.claim_date ? "".concat(moment(claim.claim_date).format("DD-MM-YYYY HH:mm"), " hrs") : "-"), /*#__PURE__*/React.createElement("td", {
      className: "claim-provision"
    }, claim.forecast_price ? "".concat(poliza.currency, " ").concat(claim.forecast_price) : "-"), /*#__PURE__*/React.createElement("td", null, claim.address || "-"), /*#__PURE__*/React.createElement("td", {
      className: "claim-status"
    }, colorStatus(claim.status), " ", claimStatusFormatted(claim.status)), /*#__PURE__*/React.createElement("td", null, claim !== null && claim !== void 0 && claim.document ? /*#__PURE__*/React.createElement("a", {
      href: claim === null || claim === void 0 ? void 0 : (_claim$document = claim.document) === null || _claim$document === void 0 ? void 0 : _claim$document.url,
      target: "_blank",
      className: "claim-file-link"
    }, /*#__PURE__*/React.createElement(FaFile, {
      className: "claim-file-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "claim-file-name"
    }, claim === null || claim === void 0 ? void 0 : (_claim$document2 = claim.document) === null || _claim$document2 === void 0 ? void 0 : _claim$document2.name)) : "-", claim === null || claim === void 0 ? void 0 : (_claim$claim_document = claim.claim_documents) === null || _claim$claim_document === void 0 ? void 0 : _claim$claim_document.map(function (doc, idx) {
      var _CLAIM_DOCUMENT_TYPES;

      return /*#__PURE__*/React.createElement("a", {
        href: doc === null || doc === void 0 ? void 0 : doc.document_url,
        target: "_blank",
        className: "claim-file-link",
        key: doc.id || idx
      }, /*#__PURE__*/React.createElement(FaFile, {
        className: "claim-file-icon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "claim-file-type"
      }, (_CLAIM_DOCUMENT_TYPES = CLAIM_DOCUMENT_TYPES.find(function (t) {
        return t.value === doc.type;
      })) === null || _CLAIM_DOCUMENT_TYPES === void 0 ? void 0 : _CLAIM_DOCUMENT_TYPES.label), /*#__PURE__*/React.createElement("span", {
        className: "claim-file-sep"
      }, "-"), /*#__PURE__*/React.createElement("span", {
        className: "claim-file-name"
      }, doc === null || doc === void 0 ? void 0 : doc.document_name));
    })), /*#__PURE__*/React.createElement("td", null, claim.paid ? "✔️" : ""), /*#__PURE__*/React.createElement("td", {
      className: "groupButtons claim-actions"
    }, canEdit && /*#__PURE__*/React.createElement("a", {
      className: "btn btn-warning",
      href: "/admin/polizas/".concat(poliza.id, "/claims/").concat(claim.id, "/edit")
    }, /*#__PURE__*/React.createElement(FaPen, null), " Editar"), canDelete && /*#__PURE__*/React.createElement("a", {
      href: "/admin/polizas/".concat(poliza.id, "/claims/").concat(claim.id),
      className: "btn btn-danger",
      "data-confirm": "Est\xE1s seguro de ELIMINAR el siniestro ".concat(claim === null || claim === void 0 ? void 0 : claim.id, "?"),
      rel: "nofollow",
      "data-method": "delete"
    }, /*#__PURE__*/React.createElement(FaTrashAlt, null), " Eliminar")));
  })))));
};

export default ListClaims;